import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
  CheckmarkCircleRegular,
  CircleRegular,
  WarningRegular,
  ErrorCircleRegular,
} from '@fluentui/react-icons';

import { Status } from '../const';
import { useStyles } from '../styles/icon-styles';

export function StatusIcon({
  status,
}) {
  const classes = useStyles();
  const {
    IconElement,
    parentClass,
    childClass,
  } = useMemo(() => {
    if (status === Status.Active) {
      return {
        IconElement: CheckmarkCircleRegular,
        parentClass: classes.parentActive,
        childClass: classes.childActive,
      };
    } else if (status === Status.Pending) {
      return {
        IconElement: CircleRegular,
        parentClass: classes.parentPending,
        childClass: classes.childPending,
      };
    } else if (status === Status.Warning) {
      return {
        IconElement: WarningRegular,
        parentClass: classes.parentWarning,
        childClass: classes.childWarning,
      };
    }

    return {
      IconElement: ErrorCircleRegular,
      parentClass: classes.parentError,
      childClass: classes.childError,
    };
  }, [classes, status]);

  return (
    <div className={classNames(parentClass, 'ba-status-item-icon-container', `ba-icon-${status}`)}>
      <IconElement className={classNames(childClass, 'ba-status-item-icon')} />
    </div>
  );
}

StatusIcon.propTypes = {
  status: PropTypes.oneOf(Object.values(Status)).isRequired,
};
